import type { PartnerClient } from '../types';

const DAY = 86_400_000;

/** What needs a person's eye, from the relationship data the portal really has. Nothing about payroll: no payroll data reaches the portal yet. */
export function attention(clients: PartnerClient[], now: number): { client: PartnerClient; why: string }[] {
  const items: { client: PartnerClient; why: string }[] = [];
  for (const client of clients) {
    if (client.status === 'Suspended') {
      items.push({ client, why: 'The client suspended your access.' });
    }

    if ((client.status === 'Active' || client.status === 'Onboarding') && client.accessExpiresAtUtc) {
      const days = Math.ceil((new Date(client.accessExpiresAtUtc).getTime() - now) / DAY);
      if (days <= 30) items.push({ client, why: days <= 0 ? 'Access has expired.' : `Access ends in ${days} day${days === 1 ? '' : 's'}.` });
    }

    if ((client.status === 'InvitationSent' || client.status === 'AwaitingClientAcceptance') && client.invitationExpiresAtUtc) {
      const days = Math.ceil((new Date(client.invitationExpiresAtUtc).getTime() - now) / DAY);
      if (days <= 3) items.push({ client, why: days <= 0 ? 'The invitation has expired. Re-send it.' : `The invitation expires in ${days} day${days === 1 ? '' : 's'}.` });
    }
  }

  return items;
}
